import React from "react";
import GenericMSDSFilesListing from "./GenericMSDSFilesListing";

function ReadOnlyMSDSFilesListing() {
  return (
    <GenericMSDSFilesListing readOnly = {true}   />
  );
}

export default ReadOnlyMSDSFilesListing;